<template>
  <div class="chemical_container">
    <div class="title">
      <img class="title_img"
           src="../../../../assets/images/09/weixian_icon.png"
           alt="">
      危险货物运输安全卡
    </div>
    <div class="search">
      化学品名
      <el-input size="small"
                v-model="searchInput"
                placeholder="请输入化学品名"></el-input>
      <el-button type="primary"
                 class="search_btn"
                 @click="handleSearchClick">查询</el-button>
      <router-link to="chemical/addChemical">
        <el-button type="warning"
                   size="small"
                   class="add_btn">添加</el-button>
      </router-link>
    </div>
    <div class="factory_main">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         width="50"
                         fixed>
        </el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         label="化学品名称">
          <template slot-scope="scope">
            <div size="medium">{{scope.row.chemicalsName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="英文名"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.englishName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="alias"
                         label="化学品分类"
                         header-align="center"
                         align="center">
        </el-table-column>
        <el-table-column prop="dangerousGoodsCategory"
                         label="危险品类别"
                         header-align="center"
                         align="center">
        </el-table-column>
        <el-table-column header-align="center"
                         prop="unCode"
                         label="UN编码"
                         align="center"></el-table-column>
        <el-table-column header-align="center"
                         prop="cnCode"
                         label="CN编码"
                         align="center"></el-table-column>
        <el-table-column header-align="center"
                         label="添加时间"
                         width="88"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.createDate | formatDate}}</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         prop="remarks"
                         label="备注"
                         align="center"></el-table-column>
        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="160">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleDeleteClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item detail"
                        effect="dark"
                        content="详情"
                        placement="top">
              <el-button @click="handleDetailClick(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getSafetyCardList,
  deleteSafetyCard
} from 'apis/index'
import { formatDate } from 'common/common.js'
export default {
  name: 'Container',
  data () {
    return {
      searchInput: '',
      data: {}
    }
  },
  methods: {
    getData (name) { // 获取信息
      getSafetyCardList({
        chemicalsName: name || ''
      }).then(res => {
        // console.log(res)
        if (res.data.code === 0) {
          this.data = res.data.data
        }
      })
    },
    handleSearchClick () { // 查询
      this.getData(this.searchInput)
    },
    handleUpdateClick (id) { // 修改
      this.$router.push({ path: 'chemical/addChemical', query: { item: id } })
    },
    handleCurrentChange (val) { // 页面切换
      let pageNum = val
      getSafetyCardList({ pageNum }).then(res => {
        this.data = res.data.data
      })
    },
    handleDeleteClick (id) { // 删除
      // console.log(id)
      deleteSafetyCard({ id: id }).then(res => {
        if (res.data.code === 0) {
          // console.log(res)
          for (var i = 0; i < this.data.result.length; i++) { // 从当前列别表中删除该数据
            if (this.data.result[i].id === id) {
              this.data.result.splice(i, 1)
            }
          }
        }
      })
    },
    handleDetailClick (id) { // 查看详情
      this.$router.push({ path: 'chemical/chemicalDetail', query: { item: id } })
    }
  },
  mounted () {
    this.getData()
  },
  filters: {
    formatDate (tiem) {
      let date = new Date(tiem)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.chemical_container
  height 100%
  padding 20px
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    background #ffffff
    img
      margin-left 20px
  .search
    width calc(100% - 20px)
    height 40px
    background #fff
    padding-top 10px
    padding-left 20px
    .el-input
      margin-left 10px
      width 210px
    .search_btn
      searchBtn()
    .add_btn
      addBtn()
      margin-right 20px
      float right
  .factory_main
    height calc(100% - 170px)
    overflow hidden
  .el-table
    background #f7f9fb
    th
      background #e7f0f8
    td
      .cell
        size12()
        .item
          padding 6px 14px
          width 28px
          cursor pointer
          height 28px
          margin 0 8px
          &.update
            background url('../../../../assets/images/03/icon_x.png') no-repeat
            &:hover
              background url('../../../../assets/images/03/icon_xh.png') no-repeat
          &.unblocked
            background url('../../../../assets/images/05/jinyong_icon.png') no-repeat
            &:hover
              background url('../../../../assets/images/05/jiejin_icon.png') no-repeat
          &.delete
            background url('../../../../assets/images/03/icon_delete.png') no-repeat
            &:hover
              background url('../../../../assets/images/03/icon_deleteh.png') no-repeat
          &.detail
            background url('../../../../assets/images/07/xiangq_n_icon.png') no-repeat
            &:hover
              background url('../../../../assets/images/07/xiangq_h_icon.png') no-repeat
  .el-pagination
    color #5e656f
    font-weight 100
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
    background transparent
    border 1px solid #cfd5dc
  .pages
    margin-top 15px
    .demonstartion
      float right
      line-height 45px
      color #5e656f
</style>
